<script>
import { columns } from "./columns";
export default {
    name: "VisitsListing",

    data() {

        return {
            columns,
            patients: []
        };
    },

    mounted() {

      this.$root.loading = true;
      Promise.allSettled([ this.fetchPatients() ]).then(() => {
        this.$root.loading = false;
      }).catch(() => {
        this.$root.loading = false;
      });
    },

    methods: {

        fetchPatients() {

            return this.$http.get(`Shared/GetPatients`).then(response => {
                this.patients = response.data;
            }).catch(() => {});
        }
    }
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:breadcrum>
            <li>Visits - Visit patient</li>
        </template>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <div class="flex w-full md:flex-row sm:flex-col">
                  <h5 class="font-medium">Visits</h5>
                </div>
              </template>
              <template v-slot:card-body>
                <data-table
                 :rows="patients"
                 :columns="columns">
                    <template v-slot:row="props">
                       <div v-if="props.row.column.field == 'action'">
                        <!-- <router-link class="btn-sm btn-primary text-xs" :to="{ name: 'visits.visit.create', params: { id: props.row.row.patienT_ID }}"> <i class="fa fa-edit"></i></router-link> -->
                        <router-link class="btn-sm btn-primary text-xs" :to="{ name: 'registration.visit-patient.create', params: { id: props.row.row.patienT_ID }}"> <i class="fa fa-edit"></i></router-link>
                       </div>
                    </template>
                </data-table>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
